import 'css-chunk:src/feature/payment/CheckPagePayment.module.scss';export default {
  "root": "CheckPagePayment_root",
  "grid-col4": "CheckPagePayment_grid-col4",
  "grid-col5": "CheckPagePayment_grid-col5",
  "grid-col2": "CheckPagePayment_grid-col2",
  "activity-root": "CheckPagePayment_activity-root",
  "activity": "CheckPagePayment_activity"
};